/**********************************************************************************************************
 *   BASE IMPORT
 **********************************************************************************************************/
import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'

/**********************************************************************************************************
 *   BASE STYLES
 **********************************************************************************************************/
import '@nexigendigital/nxui/dist/index.css'
import 'components/styles/nprogress.css'

/**********************************************************************************************************
 *   APP IMPORT
 **********************************************************************************************************/
import { App } from 'App/app'
import reportWebVitals from './reportWebVitals'
import { store } from 'store/store'

ReactDOM.render(
    <React.StrictMode>
        <Provider store={store}>
            <BrowserRouter>
                <App />
            </BrowserRouter>
        </Provider>
    </React.StrictMode>,
    document.getElementById('app-root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
